import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FreeEvaluationStatus, MidYearEvaluation } from 'src/app/free-evaluation-mid-year/_interfaces/mid-year-evaluation.interface';
import { ProcessConfig, QuestionConfig, QuestionConfigTypeEnum } from 'src/app/shared/interfaces/process-config.interface';
import { EvaluatedUser } from 'src/app/free-evaluation-mid-year/_interfaces/evaluated-user.interface';
import { EndYearEvaluation } from 'src/app/free-evaluation-end-year/_interfaces/end-year-evaluation.interface';
import { FreeEvaluationType } from 'src/app/shared/components/free-evaluation-users-list/interfaces/free-evaluation-type';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { FreeEvaluationEndYearRule } from 'src/app/shared/interfaces/end-year-evaluation-rule.interface';
import { ProcessStatusEnum } from 'src/app/shared/interfaces/process.interface';

@Component({
    selector: 'app-free-evaluation-users-list',
    templateUrl: './free-evaluation-users-list.component.html',
    styleUrls: ['./free-evaluation-users-list.component.scss'],
})
export class FreeEvaluationUsersListComponent implements OnInit {

    @Input() users: Array<EvaluatedUser> = [];
    private _evaluations: Array<MidYearEvaluation> | Array<EndYearEvaluation> = [];
    @Input()
    public get evaluations(): Array<MidYearEvaluation> | Array<EndYearEvaluation> {
        return this._evaluations;
    }
    public set evaluations(value: Array<MidYearEvaluation> | Array<EndYearEvaluation>) {
        this._evaluations = value;
    }
    @Input() freeEvaluationType: FreeEvaluationType = null;
    @Input() canReopenOrDeleteEvaluation: boolean = false;
    @Input() processConfig: ProcessConfig;
    @Input() endYearEvalRule: FreeEvaluationEndYearRule;
    @Input() translationService: TranslationService;
    @Input() sendLimitFinalEvaluationRule: boolean;
    @Input() status: ProcessStatusEnum;

    @Output() confirmDeleteEvaluationFunction: EventEmitter<{ evaluation: MidYearEvaluation | EndYearEvaluation }> = new EventEmitter<{
        evaluation: MidYearEvaluation | EndYearEvaluation
    }>();
    @Output() editEvaluationFunction: EventEmitter<{ evaluation: MidYearEvaluation | EndYearEvaluation, processConfig: ProcessConfig }> = new EventEmitter<{
        evaluation: MidYearEvaluation | EndYearEvaluation,
        processConfig: ProcessConfig
    }>();
    @Output() reopenEvaluationFunction: EventEmitter<{ evaluation: MidYearEvaluation | EndYearEvaluation }> = new EventEmitter<{
        evaluation: MidYearEvaluation | EndYearEvaluation
    }>();
    @Output() sendEvaluationFunction: EventEmitter<{ evaluation: MidYearEvaluation | EndYearEvaluation }> = new EventEmitter<{
        evaluation: MidYearEvaluation | EndYearEvaluation
    }>();

    constructor() {
    }

    ngOnInit() {
    }

    public confirmDeleteEvaluation(evaluation: MidYearEvaluation | EndYearEvaluation) {
        this.confirmDeleteEvaluationFunction.emit({ evaluation });
    }

    public editEvaluation(evaluation: MidYearEvaluation | EndYearEvaluation, processConfig: ProcessConfig) {
        this.editEvaluationFunction.emit({ evaluation, processConfig });
    }

    public reopenEvaluation(evaluation: MidYearEvaluation | EndYearEvaluation) {
        this.reopenEvaluationFunction.emit({ evaluation });
    }

    public sendEvaluation(evaluation: MidYearEvaluation | EndYearEvaluation) {
        this.sendEvaluationFunction.emit({ evaluation });
    }

    public getConcept(evaluation: MidYearEvaluation | EndYearEvaluation,
                      color: boolean) {
        let question = this.getQuestion();
        if (question === null) return;

        let finalConceptEvalField = evaluation[`field${question.order}`];

        let finalConceptDescription: string = '';

        let possibleValues = question.typeConfig.possibleValues;
        let possibleValuesGlobalized = question.typeConfig.possibleValuesGlobalized;
        let possibleValuesGlobalizedTranslated = possibleValuesGlobalized[this.translationService.getSelectedLanguage()];

        let finalConceptReferenceField = possibleValuesGlobalizedTranslated[possibleValues.findIndex((possible) => {
            return possible === finalConceptEvalField
        })];

        finalConceptDescription = Number.isNaN(parseInt(finalConceptEvalField)) || finalConceptReferenceField ?
                finalConceptReferenceField:
                possibleValuesGlobalizedTranslated[finalConceptEvalField];

        if (!color)
            return (finalConceptDescription);

        if (!this.sendLimitFinalEvaluationRule)
            return '';

        return this.getColorLabel(question, finalConceptEvalField);
    }

    public getQuestion() {
        let questionGroupsIndex = -1;
        let questionIndex = -1;

        this.processConfig.questionsGroups.forEach((questionGroup, index) => {
            let qIndex = questionGroup.questions.findIndex(question => question.type === QuestionConfigTypeEnum.FinalGrade);
            if (qIndex !== -1) {
                questionIndex = qIndex;
                questionGroupsIndex = index;
            }
        });

        if (questionGroupsIndex === -1 || questionIndex === -1) return null;

        let questionGroups = this.processConfig.questionsGroups[questionGroupsIndex];

        return questionGroups.questions[questionIndex];
    }

    public getColorLabel(question: QuestionConfig, finalConceptEvalField: string) {
        let possibleConfigConcepts = question.typeConfig.possibleValues;
        let lastConcept = possibleConfigConcepts[possibleConfigConcepts.length - 1];
        let penultimateConcept = possibleConfigConcepts[possibleConfigConcepts.length - 2];

        let isLast = finalConceptEvalField === lastConcept;
        let isPenultimate = finalConceptEvalField === penultimateConcept;
        let isRemaining = finalConceptEvalField !== lastConcept && finalConceptEvalField !== penultimateConcept;

        let isInsideLastLimit = this.endYearEvalRule.lastSelecteds <= this.endYearEvalRule.maxLast;
        let isInsidePenultimateLimit = (this.endYearEvalRule.penultimateSelecteds + this.endYearEvalRule.lastSelecteds) <= this.endYearEvalRule.maxPenultimate;
        let isInsideRemainingLimit = this.endYearEvalRule.remainingSelecteds <= this.endYearEvalRule.maxRemaining;

        let isInsidePositiveEvaluationLimit = isInsidePenultimateLimit && isInsideLastLimit;

        if (isInsidePositiveEvaluationLimit && (isLast || isPenultimate) ||
                (isRemaining && isInsideRemainingLimit))
            return 'success';
        else
            return 'danger';
    }

    public readonly FreeEvaluationStatus = FreeEvaluationStatus;
    public readonly FreeEvaluationType = FreeEvaluationType;
    public readonly ProcessStatusEnum = ProcessStatusEnum;
}
